if (!customElements.get('ft-size-guide')) {
  customElements.define('ft-size-guide', class extends HTMLElement {
    connectedCallback() {
      this.root = document.getElementById(this.dataset.productInfo) || this.closest('product-info');
      if (!this.root) return;
      this.sync = () => {
        const selected = this.root.querySelector('[data-ft-size-option] input:checked, [data-ft-size-option] select');
        const value = selected?.value?.toUpperCase().replace('2XL', 'XXL');
        this.querySelectorAll('[data-size-row]').forEach(row => row.classList.toggle('is-selected', row.dataset.sizeRow === value));
      };
      this.root.addEventListener('change', this.sync);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, this.sync);
      }
      this.sync();
    }
    disconnectedCallback() {
      this.root?.removeEventListener('change', this.sync);
      this.unsubscribe?.();
    }
  });
}
